import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_2 = { style: {"flex":"1","z-index":"2"} }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-center mt-4" }

import taccuinoSchema from "@/../../EshJSLib/models/form/taccuinoForm.json";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { ref, reactive, onMounted } from "vue";
import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { Taccuino } from "@/../../EshJSLib/models/patient";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { useRouter } from "vue-router";
import { getTaccuinoImage } from "@/../../EshJSLib/services/taccuinoService";
import taccuinoView from '@/views/Taccuino/taccuinoView.vue';
import taccuinoLock from '@/views/Taccuino/taccuinoLock.vue';

import { Modal } from "flowbite-vue";
import { hasPermission } from "../../../../EshJSLib/services/securityServices";


interface ModalStatus {
  base: boolean;
  delete: boolean;
  confidenzialita: boolean;
  showImage: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TaccuinoPage',
  setup(__props) {

const router = useRouter();
const isShownModalSub = reactive({
  alert: false,
  movePage: false,
  confirm: false,
  alertMove: false,
});

function movePage() {
  router.push({ path: 'Paypal' })
}

const showLoading = ref(false);
const viewModal = ref<InstanceType<typeof taccuinoView> | null>(null);
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const lockModal = ref<InstanceType<typeof taccuinoLock> | null>(null);

const store = patientStore();
const { patient } = storeToRefs(store);

const imageDataUrl = ref("");
const imageDataBackUrl = ref("");

const isShowModal: ModalStatus = reactive({
  base: false,
  delete: false,
  confidenzialita: false,
  showImage: false,
});
onMounted(async () => { store.fetchTaccuinos(); });

async function getImageAnteriore(row: Taccuino) {
  try {
    showLoading.value = true;
    await getTaccuinoImage(row.id_taccuino).then((result) => {

      showLoading.value = false
      imageDataUrl.value = result.taccuino_report_anteriore;
      imageDataBackUrl.value = result.taccuino_report_posteriore;

      let rowValue = patient.value.tbl_taccuinos.find(
        (taccuino) => taccuino.id_taccuino === Number(result.id_taccuino)

      );
      patient.value.tbl_taccuinos[0].taccuino_report_anteriore = result.taccuino_report_anteriore;
      patient.value.tbl_taccuinos[0].taccuino_report_posteriore = result.taccuino_report_posteriore;
    });



  } catch (error) {
    console.error("Error fetching image:", error);
  }
}

async function action(type: string, row: any, index: number, table: string) {
  console.log("Save  page taccuin o " + type);

  switch (type) {
    case "trash":
      alertModal.value.openModal('Rimuovere la segnalazione?', true).then(input => {
        if (input) { deleteTaccuino(row); }
      })
      break;
    case "pen":
    if (await hasPermission('modificataccuino')) {
        router.push(`/Registro/Taccuino/${row.id_taccuino}`);
      } else {
        isShownModalSub.alert = true;
      }
      break;
    case "lock":
      lockModal.value.openModal('', index).then((input) => {
        store.fetchTaccuinos();
      });
      break;
    case 'add':
      if (await hasPermission('aggiungitaccuino')) {
        router.push("/Registro/Taccuino/Nuova");
      } else {
        isShownModalSub.alert = true;
      }
      break;
    case 'eye':
      getImageAnteriore(row).then((result) => {
        viewModal.value.openModal('', imageDataUrl.value, imageDataBackUrl.value);
      });
      break;
  }
}

function deleteTaccuino(row: Taccuino) {
  row.deleted_at = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));
  row.id_paziente = patient.value.id_paziente;
  const delid = row.id_taccuino;

  store.savePaziente("tbl_taccuinos", row.id_taccuino).then((x) => {
    store.fetchTaccuinos();
  });
  patient.value.tbl_taccuinos = patient.value.tbl_taccuinos.filter((vac) => vac.id_taccuino != delid);
}



return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AlertModal, {
        ref_key: "alertModal",
        ref: alertModal
      }, null, 512),
      _createVNode(taccuinoView, {
        ref_key: "viewModal",
        ref: viewModal
      }, null, 512),
      _createVNode(taccuinoLock, {
        ref_key: "lockModal",
        ref: lockModal
      }, null, 512),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CollapsibleItem, {
          id: "taccuinoCollaps",
          data: _unref(taccuinoSchema),
          onRowActions: _cache[0] || (_cache[0] = (n, r, i) => action(n, r, i, 'taccuinos')),
          onCreateForm: _cache[1] || (_cache[1] = ($event: any) => (action('add', '', 0, 'taccuinos')))
        }, null, 8, ["data"])
      ])
    ]),
    (showLoading.value)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : _createCommentVNode("", true),
    (isShownModalSub.alert)
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 1,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (isShownModalSub.alert = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isShownModalSub.alert = false)),
                type: "button",
                class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
              }, _toDisplayString(_ctx.$t("Annulla")), 1),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (movePage())),
                type: "button",
                class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
              }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})